export const DismissalDecisionVI = {
    "decisionDismissal" : {
        "title": {
            "add": "Tạo mới quyết định miễn nhiệm",
            "update": "Cập nhật quyết định miễn nhiệm",
            "detail": "Chi tiết quyết định miễn nhiệm"
        },
        "placeholder": {
            "no": "QD001",
            "decisionDate": "DD/MM/YYYY",
            "decisionMaker": "Nhập cấp ra quyết định",
            "validityDate": "DD/MM/YYYY",
            "employee": "Nhập nhân viên miễn nhiệm",
            "reasonDecision": "Nhập lý do",
            "currentDepartment": "Phòng ban cũ",
            "currentJobPosition": "Vị trí cũ",
            "currentJobTitle": "Chức vụ cũ",
            "description": "Nhập mô tả"
        },
        "label": {
            "no": "Số quyết định",
            "decisionDate": "Ngày quyết định",
            "decisionMaker": "Cấp ra quyết định",
            "validityDate": "Ngày hiệu lực",
            "employee": "Nhân viên miễn nhiệm",
            "reasonDecision": "Lý do miễn nhiệm",
            "currentDepartment": "Phòng ban cũ",
            "currentJobPosition": "Vị trí cũ",
            "currentJobTitle": "Chức vụ cũ",
            "description": "Mô tả"
        }
    }
}